import {
  ClaimDocumentTypesAction,
  ClaimDocumentTypesActionTypes
} from './claim-document-types.actions';
import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

export const CLAIMDOCUMENTTYPES_FEATURE_KEY = 'clClaimDocumentTypes';

/**
 * Interface for the 'ClaimDocumentTypes' data used in
 *  - ClaimDocumentTypesState, and
 *  - claimDocumentTypesReducer
 *
 *  Note: replace if already defined in another module
 */

/* tslint:disable:no-empty-interface */
export interface ClaimDocumentType {
  id: number;
  description: string;
  ownerType: string;
  typeId: number;
  typeName: string;
  numberOfDocumentsAllowed: number;
  claimLineTypeId: number;
  mandatory: boolean;
}

export const claimDocumentTypeEntityAdapter: EntityAdapter<
  ClaimDocumentType
> = createEntityAdapter<ClaimDocumentType>({
  selectId: (claimDocumentType: ClaimDocumentType) => claimDocumentType.id,
  sortComparer: false
});

export interface ClaimDocumentTypesState
  extends EntityState<ClaimDocumentType> {
  selectedId?: number; // which ClaimDocumentTypes record has been selected
  selectedIds: number[];
  loaded: boolean; // has the ClaimDocumentTypes list been loaded
  loading: boolean;
  error?: any; // last none error (if any)
}

export interface ClaimDocumentTypesPartialState {
  readonly [CLAIMDOCUMENTTYPES_FEATURE_KEY]: ClaimDocumentTypesState;
}

export const initialState: ClaimDocumentTypesState = claimDocumentTypeEntityAdapter.getInitialState(
  {
    selectedIds: [],
    loaded: false,
    loading: false
  }
);

export function claimDocumentTypesReducer(
  state: ClaimDocumentTypesState = initialState,
  action: ClaimDocumentTypesAction
): ClaimDocumentTypesState {
  switch (action.type) {
    case ClaimDocumentTypesActionTypes.LOAD_DOCUMENT_TYPES:
      return {
        ...state,
        loaded: false,
        loading: true,
        error: undefined
      };

    case ClaimDocumentTypesActionTypes.LOAD_DOCUMENT_TYPES_SUCCESS:
      return {
        ...claimDocumentTypeEntityAdapter.addAll(action.payload, state),
        selectedIds: action.payload.map(
          claimDocumentType => claimDocumentType.id
        ),
        loaded: true,
        loading: false
      };

    case ClaimDocumentTypesActionTypes.LOAD_DOCUMENT_TYPES_FAIL:
      return {
        ...state,
        loaded: false,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
